var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"table-header"},_vm._l((_vm.headersComputed),function(header,index){return _c('div',{key:header,style:({ width: _vm.widths[index] })},[_c('p',[_vm._v(_vm._s(header))])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }